import { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { GoogleAnalytics } from '@next/third-parties/google';
import { EventDto } from '@sweatpals/shared';
import { APP_ENV } from '../constants';

export const useGoogleAnalyticsTag = (props?: { event?: EventDto }): {
	enableGoogleTag: boolean;
	GTAG_ID: string;
	gaScript: ReactNode;
} => {
	const { event } = props ?? {};

	const router = useRouter();

	const [GTAG_ID, setGTAG_ID] = useState<string>('');

	const enableGoogleTag = !!GTAG_ID;

	const getGTagId = useCallback(() => {
		// enabled only on prod environment
		if (APP_ENV !== 'main') {
			return;
		}

		if (typeof event?.additionalData?.tracking?.gtagId === 'string') {
			setGTAG_ID(event.additionalData.tracking.gtagId);
		}
	}, [event?.additionalData?.tracking?.gtagId]);

	useEffect(() => {
		getGTagId();
	});

	const handleRouteChange = useCallback(() => {
		getGTagId();
	}, [getGTagId]);

	useEffect(() => {
		router.events.on('routeChangeComplete', handleRouteChange);

		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router.events, handleRouteChange]);

	const gaScript = useMemo(() => {
		if (!enableGoogleTag) {
			return null;
		}

		return <GoogleAnalytics gaId={GTAG_ID} />;
	}, [enableGoogleTag, GTAG_ID]);

	return { enableGoogleTag, GTAG_ID, gaScript };
};
